import { getField, updateField } from 'vuex-map-fields'
export const state = () => ({
  modified: false
})

export const getters = {
  getField
}

export const actions = {}

export const mutations = {
  updateField
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
